<template>
    <el-container>
        <el-header>
            <div>
                {{$t('feedback.title')}}
            </div>
        </el-header>

        <el-main>
            <div>
                <el-form class="feedback-form" label-position="right" label-width="140px" v-loading="loginLoading">
                    <!--<el-form-item label="To">
                        <el-input type="text" disabled="true" placeholder="To" v-model="email"></el-input>
                    </el-form-item>-->
                    <div v-if="hasInvalidLoginEmail" class="feedback-contact-notice">
                        {{$t('feedback.invalidEmailNoticePrefix')}}
                        <a href="mailto:goodinvoicego@gmail.com">goodinvoicego@gmail.com</a>. {{$t('feedback.invalidEmailNoticeSuffix')}}
                    </div>
                    <div class="feedback-reply-tip">{{$t('feedback.replyTip')}}</div>
                    <el-form-item class="feedback-content-field" :label="$t('feedback.content')" style="margin-right: 10%">
                        <el-input type="textarea" autofocus="true"
                                  style="border-style:solid;border-width: 1px;border-color: #dcdfe5"
                                  :autosize="{minRows: 10}" :placeholder="$t('feedback.enterDescription')"
                                  v-model="emailMessage">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button @click.native.prevent="sendFeedBackEmail" type="success"
                                   :disabled="buttonDisabledStatus">{{$t('common.send')}}
                        </el-button>
                    </el-form-item>
                </el-form>

            </div>
        </el-main>

    </el-container>
</template>

<script>
    import {validateEmail} from '@/utils/validate'

    export default {
        methods: {
            sendFeedBackEmail() {
                if (this.loginLoading || this.buttonDisabledStatus) {
                    return;
                }
                if (this.emailMessage.trim() === '') {
                    this.$message.error(this.$t('feedback.enterDescription'));
                    return;
                }
                this.loginLoading = true;
                let that = this;
                this.$axios.post('send_email_to_client', {
                    params: {
                        toEmail: that.email,
                        content: that.emailMessage.trim(),
                        emailType: 9
                    }
                }).then(response => {
                    if (response.data.errorCode === 308 || response.data.errorCode === 311) {
                        return;
                    }
                    if (response.data.errorCode !== 0) {
                        throw new Error('Feedback send failed');
                    }
                    this.$message({
                        type: 'info',
                        message: this.$t('common.sendSuccess'),
                        duration: 6000
                    });
                    this.emailMessage = "";
                }).catch(() => {
                    this.$message.error(this.$t('common.systemError'));
                }).finally(() => {
                    this.loginLoading = false;
                })
            }
        },
        computed: {
            hasInvalidLoginEmail() {
                return this.loginEmail !== '' && !validateEmail(this.loginEmail);
            },
            buttonDisabledStatus() {
                return this.loginLoading || this.hasInvalidLoginEmail
                    || this.emailMessage.trim() === '';
            }
        },
        data() {
            return {
                email: "goodinvoicego@gmail.com",
                loginEmail: "",
                feedbackContext: "",
                emailMessage: "",
                loginLoading: false
            }
        },
        mounted() {
            let loginInformation = JSON.parse(localStorage.getItem("loginInformation")).objectData;
            this.loginEmail = loginInformation.email;
            this.feedbackContext = "account: " + loginInformation.email + "\nbrowser: " + navigator.userAgent;
            this.emailMessage = this.$t('feedback.contextTip') + "\n" + this.feedbackContext + "\n\n";
        }

    }
</script>
<style scoped>
    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        font-weight: 700;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        padding: 30px;
    }

    .biaoti {
        font-size: 24px;
        padding-left: 1%;
    }

    /deep/ .el-input__inner {
        width: 60%;
        margin-left: 2%;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
    }

    /deep/ .taxListButton {
        border-style: none none solid none;
        background-color: white;
        border-radius: 0px;
        width: 15%;
        text-align: left;
    }

    .taxItemList {
        margin-bottom: 10px;
    }

    .taxListform {
        margin-left: 10%;
        margin-top: 20px;
    }

    .feedback-reply-tip {
        margin: 0 10% 12px 140px;
        color: #606266;
        font-size: 15px;
        line-height: 22px;
    }

    .feedback-contact-notice {
        margin: 0 10% 16px 140px;
        padding: 14px 16px;
        border: 1px solid #F5C2C7;
        border-radius: 6px;
        color: #842029;
        background: #FFF5F5;
        font-size: 15px;
        line-height: 24px;
    }

    .feedback-contact-notice a {
        color: #0D7DF7;
        font-weight: 600;
    }

    .feedback-character-count {
        margin-top: 6px;
        color: #909399;
        font-size: 12px;
        line-height: 18px;
        text-align: right;
    }

    .feedback-character-count.is-invalid {
        color: #F56C6C;
    }

    /deep/ .el-select {
        display: block;
    }

    /deep/ .el-input__suffix {
        left: 0;
    }

    /*去掉textarea右下角样式*/
    /deep/ .el-textarea__inner {
        resize: none;
    }

    @media (max-width: 640px) {
        /deep/ .el-header {
            height: 86px !important;
            padding: 28px 72px 20px 20px;
        }

        /deep/ .el-main {
            padding: 24px 20px;
        }

        .feedback-reply-tip,
        .feedback-contact-notice {
            margin-right: 0;
            margin-left: 0;
        }

        .feedback-form >>> .el-form-item {
            display: block;
            margin-right: 0 !important;
        }

        .feedback-form >>> .el-form-item__label {
            float: none;
            width: 100% !important;
            padding-right: 0;
            text-align: left;
        }

        .feedback-form >>> .el-form-item__content {
            margin-left: 0 !important;
        }

        .feedback-content-field >>> .el-textarea,
        .feedback-content-field >>> .el-textarea__inner {
            width: 100%;
        }
    }
</style>
<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }
</style>
